<template>
  <div class="flex justify-start items-center">
    <img
      v-if="imageExists"
      class="flight-box__airline-logo"
      :src="imageSrc"
      :alt="airlineName"
      @error="imageExists = false"
    />
    <div
      class="airline-name"
      :class="{'ml-4': imageExists}"
    >
      {{ airlineName }}
    </div>
  </div>
</template>

<script>
import carrierInfo from '@packages/air/airlines.js'

export default defineNuxtComponent({
  name: 'AirlineLabel',

  props: {
    carrierCode: {
      type: String,
      required: true,
    },
  },

  data () {
    return {
      imageExists: true,
    }
  },

  computed: {
    airlineName () {
      return carrierInfo[this.carrierCode]?.name || this.carrierCode
    },

    imageSrc () {
      return `/airline-logos/${this.carrierCode}.png`
    },
  },
})
</script>

<style lang="scss" scoped>
@import "@layers/web/assets/scss/modules/charter/_flight-box";
</style>
